<div class="kt-portlet">
    <div cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragHandle class="kt-portlet__head kt-portlet__head__custom">
        <div class="kt-portlet__head-label">
            <h5 class="kt-portlet__head-title">Are you absolutely sure?</h5>
        </div>
    </div>
    <div class="kt-portlet__body">
        <div class="kt-form">
            This action <b>cannot</b> be undone. This will permanently delete the data available for system {{this.data.system}}.
            <br>
            Please type <b>{{this.data.system}}</b> to confirm.
            <kt-input class="d-block my-2" [(ngModel)]="confirmText"></kt-input>
            <div class="kt-portlet__foot kt-portlet__no-border kt-portlet__foot--fit text-right">
                <div class="kt-form__actions kt-form__actions--sm">
                    <kt-button-v1 mat-dialog-close variant="stroked" theme="muted" label="Cancel" class="mb-3"></kt-button-v1>&nbsp;
                    <kt-button-v1 variant="flat" theme="danger" [disabled]="confirmText !== this.data.system"
                        label="I agree, delete {{this.data.system}}'s data" (btnClick)="deleteHandler($event)"></kt-button-v1>
                </div>
            </div>
        </div>
    </div>
</div>
